module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"uk":{"app-store":"Завантажити з App Store","google-play":"Завантажити з Google Play"},"en":{"app-store":"Download on the App Store","google-play":"Get it on Google Play"}}')
  delete Component.options._Ctor
}
